(function() {
    'use strict';

    function collapseBuilds() {
      var lines = window.cca_cart_lines || [];
      if (!lines.length) return;

      var groups = {};
      lines.forEach(function(line) {
        if (!line.build_id) return;
        (groups[line.build_id] = groups[line.build_id] || []).push(line);
      });

      Object.keys(groups).forEach(function(buildId) {
        var group = groups[buildId].slice().sort(function(a,b) { return Number(!!(b.properties && b.properties.Shaft)) - Number(!!(a.properties && a.properties.Shaft)); });
        if (group.length < 2) return;

        var rows = group.map(function(l) {
          return document.querySelector(
            '#CartItem-' + l.index + ', ' +
            '[data-key="' + l.key + '"], ' +
            '[data-cart-item-key="' + l.key + '"]'
          );
        }).filter(Boolean);

        if (rows.length < 2) return;

        var first = rows[0];
        if (first.dataset.ccaCollapsed === '1') return;
        first.dataset.ccaCollapsed = '1';
        first.dataset.ccaBuildId = buildId;

        var totalCents = group.reduce(function(s, l) { return s + l.final_line_price; }, 0);
        var totalFmt = formatMoney(totalCents);

        var titleEl = first.querySelector(
          '.cart-item__name, .cart-item__title, .cart-item-name, a.cart-item__name'
        );
        if (titleEl) titleEl.textContent = 'Custom Arrow Build';

        var firstProps = group[0].properties || {};
        group.forEach(function(l) {
          if (Object.keys(l.properties || {}).length > Object.keys(firstProps).length) {
            firstProps = l.properties;
          }
        });

        var summaryHtml = buildSummaryHtml(firstProps);
        var detailsContainer = first.querySelector(
          '.cart-item__details, .cart-item__inner, td.cart-item__details'
        );
        if (detailsContainer) {
          detailsContainer.querySelectorAll(
            '.product-option, dl, .cart-item__property, .cart-item__options'
          ).forEach(function(n) { n.remove(); });
          detailsContainer.insertAdjacentHTML('beforeend', summaryHtml);
        }

        first.querySelectorAll(
          '.cart-item__price, .cart-item__final-price, .price__regular .price-item, ' +
          '.price-item--regular, .cart-item__totals .price'
        ).forEach(function(p) { p.textContent = totalFmt; });

       // Hide just the quantity stepper input — keep the remove (trash) button visible
        first.querySelectorAll('quantity-input').forEach(function(el) {
          el.style.display = 'none';
        });

        rows.slice(1).forEach(function(row) { row.style.display = 'none'; });
      });
    }

    function removeBuild(group) {
      var updates = {};
      group.forEach(function(l) { updates[l.key] = 0; });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function() { window.location.reload(); });
    }

    function buildSummaryHtml(props) {
      var order = [
        'Shaft', 'Included Insert', 'Length', 'Spine',
        'Fletching', 'Colours', 'Quantity',
        'Insert Upgrade', 'Field Point', 'Services'
      ];
      var rows = [];
      order.forEach(function(k) {
        if (props[k]) {
          rows.push(
            '<div style="display:flex;gap:8px;font-size:13px;line-height:1.5;">' +
              '<span style="color:#6c757d;min-width:110px;">' + escapeHtml(k) + '</span>' +
              '<span>' + escapeHtml(props[k]) + '</span>' +
            '</div>'
          );
        }
      });
      return '<div class="cca-cart-summary" style="margin-top:8px;">' + rows.join('') + '</div>';
    }

    function formatMoney(cents) {
      return 'R' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function escapeHtml(s) {
      return String(s).replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function run() {
      try { collapseBuilds(); } catch (e) { console.error('[cca-cart-collapse]', e); }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('cart:updated', run);
    document.addEventListener('cart-drawer:updated', run);

    // Capture-phase remove handler — beats Dawn's own click listener
    document.addEventListener('click', function(ev) {
      var row = ev.target.closest('[data-cca-build-id]');
      if (!row) return;
      var trigger = ev.target.closest(
        'cart-remove-button, cart-remove-button a, ' +
        '.cart-item__remove, [data-cart-remove], ' +
        'a[href*="/cart/change"], a[href*="/change?"]'
      );
      if (!trigger) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var buildId = row.dataset.ccaBuildId;
      var group = (window.cca_cart_lines || []).filter(function(l) {
        return l.build_id === buildId;
      });
      if (group.length) removeBuild(group);
    }, true);

    var rerunTimer = null;
    new MutationObserver(function() {
      if (rerunTimer) clearTimeout(rerunTimer);
      rerunTimer = setTimeout(run, 50);
    }).observe(document.body, { childList: true, subtree: true });
  })();